import { Component, ElementRef, ViewChild } from '@angular/core';

import { TRACKING_EVENTS } from 'src/app';
import { MixpanelService } from 'src/core/services/mixpanel.service';

@Component({
  selector: 'hb-whatsapp-chat',
  templateUrl: './whatsapp-chat.component.html',
  styleUrls: ['./whatsapp-chat.component.scss'],
})
export class WhatsappChatComponent {
  @ViewChild('whatsappLink') whatsappLink: ElementRef;

  private whatsappUrl =
    'https://wa.me/5215526905840?text=Tengo%20una%20duda%2C%20%C2%BFme%20podr%C3%ADan%20ayudar%3F';
  constructor(private readonly mixService: MixpanelService) {}

  public clickLink() {
    this.mixService.track(
      TRACKING_EVENTS.help.event,
      TRACKING_EVENTS.help.success('whatsapp'),
    );

    this.whatsappLink.nativeElement.href = this.whatsappUrl;

    this.whatsappLink.nativeElement.click();
  }
}
